import { createStore, Store } from 'vuex'
import uiModule from './modules/ui'
import bookingModule from './modules/booking'
import tourModule from './modules/tour'

export interface RootState {
  ui?: any
  booking?: any
  tour?: any
}

export default createStore<RootState>({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    ui: uiModule,
    booking: bookingModule,
    tour: tourModule
  }
})
